import { Button, Dialog, EButtonColor } from '@web_opxp/components';
import { AuthSelectors, FirebaseActions, useTranslation } from '@web_opxp/features';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { IState } from '../../store/state';
import './StatisticsSection.scss';

interface IDataExportSectionParams {
  isGroupAdmin: boolean;
  onDataExportButtonClicked: () => void;
}

export const DataExportSectionFC: React.FC<IDataExportSectionParams> = ({
  onDataExportButtonClicked,
  isGroupAdmin,
}: IDataExportSectionParams) => {
  const { t } = useTranslation();
  const [showDialog, setShowDialog] = useState(false);

  if (!isGroupAdmin) return null;

  const openDialog = () => {
    onDataExportButtonClicked();
    setShowDialog(true);
  };

  const closeDialog = () => {
    setShowDialog(false);
  };

  const sectionTitle = t('Evaluation.Overview.DataExportSection.Title');
  const exportButtonLabel = t('Evaluation.Overview.DataExportSection.ButtonLabel');
  const dataExportText = t('Evaluation.Overview.DataExportSection.Export');
  const dialogTitle = t('Evaluation.Overview.DataExportSection.DialogTitle');
  const dialogText = t('Evaluation.Overview.DataExportSection.DialogContent');
  const okButtonLabel = t('Evaluation.Overview.DataExportSection.OKButtonLabel');

  return (
    <div className="dataexport-section">
      <h3 className="dataexport-section-title">{sectionTitle}</h3>
      <div className="dataexport-section-content-wrapper">
        <p>{dataExportText}</p>
        <Button color={EButtonColor.white} label={exportButtonLabel} onClick={openDialog} />
        <Dialog
          title={dialogTitle}
          autoFocus={true}
          usePortal={true}
          isOpen={showDialog}
          onClose={closeDialog}
          footerContent={okButtonLabel && <Button label={okButtonLabel} onClick={closeDialog} />}>
          {dialogText}
        </Dialog>
      </div>
    </div>
  );
};

const mapStateToProps = (state: IState) => {
  const isGroupAdmin = AuthSelectors.isGroupAdmin(state);
  return {
    isGroupAdmin,
  };
};

export const mapDispatchToProps = {
  onDataExportButtonClicked: () => FirebaseActions.analyticsEventAction({ eventName: 'gad_export_button' }),
};

const DataExportSection = connect(mapStateToProps, mapDispatchToProps)(DataExportSectionFC);
export default DataExportSection;
